import apiClient from "../http/apiClient";
import { PRODUCTS_ENDPOINTS } from "../http/endpoints";

const detailUrl = (basePath, id) => `${basePath}${id}/`;
const toggleActiveUrl = (id) => `${PRODUCTS_ENDPOINTS.productBrands}${id}/toggle-active/`;

export async function list(params = {}) {
  const response = await apiClient.get(PRODUCTS_ENDPOINTS.productBrands, { params });
  return response.data;
}

export async function create(payload) {
  const response = await apiClient.post(PRODUCTS_ENDPOINTS.productBrands, payload);
  return response.data;
}

export async function update(id, payload) {
  const response = await apiClient.patch(detailUrl(PRODUCTS_ENDPOINTS.productBrands, id), payload);
  return response.data;
}

export async function toggleActive(id, is_active) {
  const body = {};
  if (typeof is_active === "boolean") {
    body.is_active = is_active;
  }
  const response = await apiClient.patch(toggleActiveUrl(id), body);
  return response.data;
}

export const brandsService = {
  list,
  create,
  update,
  toggleActive,
};

export default brandsService;
